import React from "react";
import { Card } from "react-bootstrap";
import { Line } from "react-chartjs-2";

import {
  Chart as ChartJS,
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Legend,
  Tooltip,
} from "chart.js";

ChartJS.register(
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Legend,
  Tooltip,
);

function ReportLineChart({ chartData }) {
  return (
    <div>
      <Card className="p-2 shadow border-0">
        <h6 className="fw-bold">Attendance</h6>

        <div style={{ height: "245px" }}>
          <Line
            data={chartData}
            options={{
              responsive: true,
              maintainAspectRatio: false,
            }}
          />
        </div>
      </Card>
      {/* STYLES */}
      <style>{`
        .fancy-card {
          border-radius: 12px;
          background: #fff;
          transition: all 0.3s ease;
          cursor: pointer;
        }

        .fancy-card:hover {
          transform: translateY(-8px) scale(1.02);
          box-shadow: 0 15px 30px rgba(0,0,0,0.15);
        }

        .overlay {
          position: absolute;
          inset: 0;
          opacity: 0;
          transition: 0.4s ease;
        }

        .fancy-card[data-type="Total Working Days"] .overlay { background: #28a745; }
        .fancy-card[data-type="Total Holidays"] .overlay { background: #dc3545; }
        .fancy-card[data-type="Total Leave Taken"] .overlay { background: #007bff; }
        .fancy-card[data-type="Total Half Days"] .overlay { background: #ffc107; }

        .fancy-card:hover .overlay {
          opacity: 0.85;
        }

        .bg-icon {
          position: absolute;
          right: 15px;
          top: 50%;
          transform: translateY(-50%);
          font-size: 60px;
          opacity: 0.12;
          transition: 0.4s ease;
        }

        .fancy-card:hover .bg-icon {
          color: #fff;
          opacity: 0.3;
        }

        .title-text,
        .count-text {
          position: relative;
          z-index: 2;
        }

        .fancy-card:hover .title-text,
        .fancy-card:hover .count-text {
          color: #fff !important;
        }

        .progress-bar {
          transition: width 1.5s ease-in-out !important;
        }
      `}</style>
    </div>
  );
}

export default ReportLineChart;